import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';

const WebsiteTopBanner = (props) => {
  return (
    <div className="flex w-12">
      <h1>三色貓聊天室</h1>
    </div>
  );
};
  
export default WebsiteTopBanner;
